/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingPageLineActivationInflowSourceFormAssignedStaffFragmentDoc } from './SettingPageLineActivationInflowSourceFormAssignedStaff.generated';
export type SettingPageLineActivationInflowSourceFormQueryFragment = { staffsByPlanner: Array<{ guid: string, displayName: string }> };

export const SettingPageLineActivationInflowSourceFormQueryFragmentDoc = gql`
    fragment SettingPageLineActivationInflowSourceFormQuery on Query {
  staffsByPlanner {
    ...SettingPageLineActivationInflowSourceFormAssignedStaff
  }
}
    ${SettingPageLineActivationInflowSourceFormAssignedStaffFragmentDoc}`;